import React from 'react';
import ReactDOM from 'react-dom';

export const setNavigationContent = (content: React.ReactNode, containerId: string) => {
  const navigationDom = document.getElementById(containerId);
  if (navigationDom) {
    return ReactDOM.createPortal(
      content,
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Assign content to nav abr.
      navigationDom as HTMLElement
    );
  }
  return null;
};

export const generateSetContent = (containerId: string) => (content: React.ReactNode) =>
  setNavigationContent(content, containerId);

export const generateMultipleSetContent = (containerId: string, containerIdTwo: string) => (content: React.ReactNode) =>
  (
    <>
      {setNavigationContent(content, containerId)}
      {setNavigationContent(content, containerIdTwo)}
    </>
  );
